import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService, GridContentWidget } from '@eforall/dashboard';
import { EventSummary } from '@interfaces';
import { AccClassEventsViewerDialogDataService } from './acc-class-events-viewer-dialog-data.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'acc-class-events-viewer-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		GridContentWidget,

	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-class-events-viewer.dialog.html',
})
export class AccClassEventsViewerDialog implements OnInit {

	public dialogContext: DialogContext<{ accName: string, events: EventSummary[] }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<AccClassEventsViewerDialog>);

	private util = inject(UtilityService);
	public dialogDataService = inject(AccClassEventsViewerDialogDataService);
	public dialogService = inject(DialogService);

	ngOnInit() {
		this.dialogDataService.setClassEvents(this.dialogContext.data?.events || []);
	}

	public setup = getSetup(this.util, this.dialogDataService, this.dialogService);

	public dialogActions: DialogAction[] = [{
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: "no-action",
		willCloseDialog: true,
	}];

}
